import { Button, DataGrid, DataGridColumn, StandardAlert } from '@cimplico/components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFirmContext } from '../../../providers/FirmProvider';
import { useFYIUsers } from '../../../queries/use-fyi-users';
import { FYIUser } from '../../../types/fyi-docs';
import FYIUserRow from './FYIUserRow';

const columns: DataGridColumn[] = [
    { alignment: 'left', header: 'Name', width: '2fr' },
    { alignment: 'left', header: 'Email', width: '2fr' },
    { alignment: 'center', header: '', width: '0.25fr' },
];

type FYIUserSelectProps = {
    onSelect: (users: FYIUser[]) => void;
};

function FYIUserSelect({ onSelect }: FYIUserSelectProps): JSX.Element {
    const navigate = useNavigate();
    const { shortId } = useFirmContext();
    const { data, isLoading } = useFYIUsers();
    const [selected, setSelected] = useState<FYIUser[]>([]);

    function handleSelect(ids: string[]): void {
        const _ids = ids.map((id) => id);
        setSelected(data?.users.filter((u) => _ids.includes(u.id.toString())) || []);
    }

    function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        onSelect(selected);
    }

    return (
        <div>
            <StandardAlert
                title="Note"
                description={[
                    'Inactive users in FYI will not be included in the list below.',
                    'Admins in FYI will be mapped to Managers in Cimplico Workpapers.',
                ]}
                type="info"
            >
                <div></div>
            </StandardAlert>
            <fieldset disabled={false} className="mt-4">
                <form onSubmit={handleSubmit}>
                    <div className="flex items-center justify-between mb-4">
                        {/* <Search placeholder="Search by name..." onChange={setSearch} /> */}
                        <p className="text-right text-sm text-gray-600">{selected.length} selected</p>
                    </div>
                    <div className="max-h-[400px] overflow-y-auto w-max min-w-[600px]">
                        <DataGrid
                            isLoading={isLoading}
                            disablePagination
                            columns={columns}
                            rowSizes={[50]}
                            totalRows={data?.users?.length || 0}
                            onSelect={handleSelect}
                        >
                            {data?.users?.map((user) => {
                                return (
                                    <FYIUserRow
                                        id={user.id.toString()}
                                        key={user.id}
                                        user={user}
                                        isSelected={Boolean(selected.find((s) => s.id === user.id))}
                                        isDisabled={user.existingMapping}
                                    />
                                );
                            })}
                        </DataGrid>
                    </div>
                    {/* FORM CANCEL + SUBMIT */}
                    <div className="flex justify-end gap-4 mt-8">
                        <Button
                            type="hollow"
                            label="Cancel"
                            onClick={(): void => navigate(`/${shortId}/settings?tab=invitations`)}
                            disabled={false}
                        />
                        <Button type="primary" label="Next" isSubmit disabled={selected.length === 0} isLoading={false} />
                    </div>
                </form>
            </fieldset>
        </div>
    );
}
export default FYIUserSelect;
